import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getLanguages = createSelector(
  (state: RootState) => state.entities.languages.byId,
  (languagesById) => Object.values(languagesById),
);
